import styled, { css } from 'styled-components';
import { fontSize } from 'modules/theme';
import { Box } from 'modules/v2/foundation/Box';
import { Typography } from 'modules/v2/foundation/Typography';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet, themeGetColor } from 'modules/v2/foundation/theme';
const primaryStyles = css `
  background-color: ${themeGetColor('primary.100')};
  border-color: ${themeGetColor('primary.300')};

  color: ${themeGet('colors.text.300')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.text.300')};
  }
`;
const secondaryStyles = css `
  background-color: ${themeGetColor('gray.50')};
  border-color: ${themeGetColor('primary.200')};

  color: ${themeGet('colors.text.200')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.text.300')};
  }
`;
const infoStyles = css `
  background-color: ${themeGetColor('blue.100')};
  border-color: ${themeGetColor('blue.300')};

  color: ${themeGet('colors.blue.900')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.blue.900')};
  }
`;
const successStyles = css `
  background-color: ${themeGetColor('green.100')};
  border-color: ${themeGetColor('green.300')};

  color: ${themeGet('colors.green.900')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.green.900')};
  }
`;
const dangerStyles = css `
  background-color: ${themeGetColor('red.100')};
  border-color: ${themeGetColor('red.300')};

  color: ${themeGet('colors.red.900')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.red.900')};
  }
`;
const warningStyles = css `
  background-color: ${themeGetColor('yellow.100')};
  border-color: ${themeGetColor('yellow.400')};

  color: ${themeGet('colors.text.200')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.text.300')};
  }
`;
const stylesFromAppearance = (props) => {
    switch (props.appearance) {
        case 'primary':
            return primaryStyles;
        case 'info':
            return infoStyles;
        case 'success':
            return successStyles;
        case 'danger':
            return dangerStyles;
        case 'warning':
            return warningStyles;
        case 'secondary':
        default:
            return secondaryStyles;
    }
};
export const Banner = styled(Box)
    .withConfig({
    shouldForwardProp: (prop) => !['appearance'].includes(prop),
})
    .attrs((p) => (Object.assign({ gap: 'md', alignItems: 'center', justifyContent: 'center', px: 'lg', py: 'md', role: 'alert' }, p))) `  
  ${fontSize('small')};
  text-align: center;
    
  border-radius: ${themeGet('borderRadius.md')};
  border: ${pxToRem(1)} solid transparent;

  line-height: ${themeGet('lineHeight.neutralized')};

  ${Typography} {
    font-size: ${themeGet('fontSize.small')};
    font-weight: ${themeGet('fontWeight.medium')};
  }

  ${stylesFromAppearance};
`;
